module.exports = __webpack_public_path__ + "static/media/testanalytic.b87d7f95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/testanalytic.svg
// module id = 1041
// module chunks = 0